import React from 'react';
import { useSelector } from 'react-redux';
import { is_empty } from 'utils/validations';
import { Droppable, Draggable } from "react-beautiful-dnd";
import RenderKeywordListings from './RenderKeywordListings';
import module_style from "../Style.module.css";
import Dots from '@material-ui/icons/DragIndicator';

const form_data = {
    unassigned: 'Unassigned listings',
    listings: 'listings',
    plans: 'plans',
}

const RenderSkuListings = ({ keywords, sku, set_add_keyword, id }) => {
    const listings_data = useSelector((state) => state.webpage_detail.listings);

    const [unassigned_listings, set_unassigned_listings] = React.useState([]);

    React.useEffect(() => {
        set_unassigned_listings(listings_data.listings_data?.listings?.filter((listing) => listing.sku_type === sku && is_empty(listing.keywords)))
    }, []);

    return (
        <Droppable className={'droppable_test'} droppableId={id} type={`KEYWORD`}>
            {(provided) => {
                return (
                    <div  className={'droppable__div_test'}
                        ref={provided.innerRef}
                    >
                        {keywords.map((item, index) => {
                            if (is_empty(item)) return <></>
                            return (
                                <Draggable
                                    key={item.id}
                                    draggableId={item.id}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div>
                                            <div ref={provided.innerRef} {...provided.draggableProps} className={`m-2`}>

                                                <div className={`${module_style.SkuCard}`}>
                                                    <div className={`mb-3 row no-gutters`}>
                                                        <div className={`${module_style.keyword_info} ${module_style.sub_heading}`}>{item.title}</div>
                                                        <div className="mr-1" style={{ cursor: "grab" }} {...provided.dragHandleProps}><Dots /></div>
                                                    </div>
                                                    <RenderKeywordListings id={item.id} listings={item.listings} set_add_keyword={set_add_keyword} />
                                                </div>
                                            </div>
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        {<div className={`m-2`}>
                            <div className={`${module_style.SkuCard}`}>
                                <div className={`mb-3 row no-gutters`}>
                                    <div className={`${module_style.keyword_info} ${module_style.sub_heading}`}>{form_data.unassigned}</div>
                                </div>
                                <RenderKeywordListings id={`${id}_keyword_unassigned`} listings={listings_data.listings_data?.listings?.filter((listing) => listing.sku_type === sku && is_empty(listing.keywords))} set_add_keyword={set_add_keyword} />
                            </div>
                        </div>}

                        {provided.placeholder}
                    </div>
                );
            }}
        </Droppable>
    )

}

export default RenderSkuListings;